import { getElementHeight } from '@/core/domHelpers';

export const detailMapping = {
  detail: 0,
  blockNumber: 1,
  annotate: 2,
  adjustPayment: 3
};

export default {
  props: {
    showLoader: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      containerHeight: 0,
      isContainerHeightChangeable: false
    };
  },
  mounted() {
    this.updateHeight();
  },
  updated() {
    this.updateHeight();
  },
  methods: {
    closeForm() {
      this.$emit('closeForm');
    },
    checkCurrentTabAndEmitHeightChangeEvent() {

      if (!this.containerHeight || this.isContainerHeightChangeable) {
        this.containerHeight = getElementHeight(this.$refs['container']);
      } 
        
      this.emitHeightChangeEvent();
    },
    emitHeightChangeEvent() {
      this.$emit('setDetailRowHeight', this.containerHeight);
    },
    updateHeight() {
      setTimeout(() => {
        this.checkCurrentTabAndEmitHeightChangeEvent();
      }, 0);
    }
  },
};